<template>
  <div>
    <el-button
      :loading="loading"
      type="success"
      @click="downloadOrders">导出物流单</el-button>
    <export-express-modal ref="export" />
  </div>
</template>
<script>
import ExportExpressModal from './export-express-modal.vue'

export default {
  name: 'ExportExpressBtn',
  components: { ExportExpressModal },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      ruleForm: {
        logisticsCode: null,
        createTime: null
      }
    }
  },
  methods: {
    downloadOrders() {
      this.$refs.export.toggleModal(true)
    }
  }
}
</script>
